module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvsUtiYySUhiCXABTV.8db2d025.woff";